import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"
import { useUserStore } from "@/lib/fetch-users"
import { useBannerStore } from "@/stores/useBannerStore"

export const UserWarningBanner = () => {
  const { t } = useTranslation()
  const isAtossDataMismatchedOrMissing = useUserStore((state) => state.isAtossDataMismatchedOrMissing)

  const bannerId = "user-warning-banner"
  const isDismissed = useBannerStore((state) => state.banners[bannerId])
  const dismissBanner = useBannerStore((state) => state.dismissBanner)

  if (isDismissed) return null

  return (
    isAtossDataMismatchedOrMissing && (
      <Banner
        type="full-width"
        variant="warning"
        className="py-0"
        iconClassName="self-auto"
        dismissOptions={{
          onDismiss: () => dismissBanner(bannerId),
        }}>
        {t("common.precheckAtossLicencedInCountriesMismatch")}
      </Banner>
    )
  )
}
